<template>
    <div>
        <v-alert type="success" dismissible v-model="success">Ügyfél sikeresen hozzáadva
        </v-alert>
        <v-alert type="error" v-model="isRefreshNeeded">Ügyfél módosítva, frissítés szükséges!
        </v-alert>
        <v-alert type="error" dismissible v-model="uploadFail">Hiba! Sikertelen mentés. Hibaüzenet: {{ this.error }}
        </v-alert>
        <v-card title="Ügyfelek" flat>
            <v-row class="ml-1 mt-2 mb-2">
                <v-col cols="3">
                    <v-text-field v-model="search" label="Keresés" prepend-inner-icon="mdi-magnify" variant="outlined"
                        hide-details single-line></v-text-field>
                </v-col>
            </v-row>
            <!-- Column filters -->
            <v-row v-if="admin" class="ml-3 mt-2 mb-4" no-gutters>
                <v-col v-for="header in filteredHeaders" :key="header.value"
                    :cols="Math.floor(8 / filteredHeaders.length)" :sm="Math.floor(8 / filteredHeaders.length)"
                    :md="Math.floor(8 / filteredHeaders.length)" :lg="Math.floor(8 / filteredHeaders.length)"
                    :xl="Math.floor(8 / filteredHeaders.length)" class="px-1">
                    <v-select v-if="getColumnType(header.value) === 'select'" v-model="columnFilters[header.value]"
                        :items="getUniqueValues(header.value)" :label="`${header.text}`" clearable multiple chips
                        deletable-chips variant="outlined" hide-details dense class="uniform-filter-field"
                        :menu-props="{ maxHeight: 300 }">
                        <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index < 1" x-small class="filter-chip">
                                {{ typeof item === 'string' ? item : (item.title || item.text || item) }}
                            </v-chip>
                            <span v-if="index === 1" class="filter-count">
                                (+{{ columnFilters[header.value].length - 1 }})
                            </span>
                        </template>
                    </v-select>
                    <v-text-field v-else v-model="columnFilters[header.value]" :label="`${header.text}`" clearable
                        variant="outlined" hide-details dense class="uniform-filter-field"></v-text-field>
                </v-col>
                <v-col class="ml-2" cols="2">
                    <v-btn color="secondary" @click="clearAllFilters()">
                        <v-icon>mdi-filter-remove</v-icon>
                    </v-btn>
                </v-col>
            </v-row>


            <v-data-table class="mt-3" :headers="tableHeaders" :items="filteredItems" :loading="loading" item-key="Id"
                :item-style="itemColor" loading-text="Adatok betöltése..." v-model="selected" :search="search"
                show-select :sort-by="['modified_date', 'created_date']" :sort-desc="[true, true]"
                @click:row="showModal" :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'mdi-arrow-collapse-left',
                    lastIcon: 'mdi-arrow-collapse-right'
                }">
                <template v-slot:[`item.comment`]="{ item }">
                    {{ extractFirstElement(item.comment) }}
                </template>
                <template v-slot:[`item.client_date`]="{ item }">
                    {{ getLastDate(item.client_date) }}
                </template>
            </v-data-table>
            <v-row>
                <v-col v-if="selected.length != 0 && admin" cols="2">
                    <v-btn rounded class="ml-2" color="error" @click="deleteClients()">ÜGYFELEK törlése</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="2">
                    <v-btn rounded class="ml-2" color="secondary" @click="openCreateDialog()">ÜGYFÉL Hozzáadása</v-btn>
                </v-col>
                <v-col cols="2">
                    <v-btn rounded v-if="admin" color="success">
                        <vue-excel-xlsx :data="items" :columns="columns" :file-name="'ugyfelek'" :file-type="'xlsx'">
                            TÁBLÁZAT LETÖLTÉSE
                        </vue-excel-xlsx>
                    </v-btn>
                </v-col>
                <v-col cols="3">
                    <v-file-input class="pt-0" v-if="admin" show-size accept=".xlsx" v-model="file"
                        label="Ügyfelek feltöltése (.xlsx)..."></v-file-input>
                </v-col>
                <v-col>
                    <v-btn rounded v-if="file" color="secondary" @click="uploadXlsx" class="ml-8">
                        Feltöltés
                    </v-btn>
                </v-col>
            </v-row>

        </v-card>

        <v-dialog transition="dialog-top-transition" v-model="dialog" width="600" scrollable persistent>
            <v-card>
                <v-alert type="error" dismissible v-model="fail">Hiba! Sikertelen mentés. Hibaüzenet: {{ this.error }}
                </v-alert>
                <v-toolbar>
                    <v-toolbar-title>{{ currentItem.product }} módosítása</v-toolbar-title>
                </v-toolbar>
                <v-divider class="mt-3"></v-divider>
                <v-card-text ref="dialogScrollArea">
                    <v-form>
                        <v-select :rules="[rules.required]" required label="Termék" v-model="currentItem.product"
                            :items="products">
                        </v-select>
                        <v-select :rules="[rules.required]" required label="Igénylés típusa"
                            v-model="currentItem.request_type" :items="sortedRequests">
                        </v-select>
                        <v-text-field required :rules="[rules.required]" label="Ügyfél neve"
                            :disabled="admin != 'administrator'" v-model="currentItem.client_name">
                        </v-text-field>
                        <v-row align="center">
                            <v-col>
                                <v-menu v-model="editmenu" :close-on-content-click="false" :nudge-right="40"
                                    transition="scale-transition" offset-y>
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-model="formattedDateEdit" label="Küldés dátuma" readonly
                                            v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="currentItem.date_sent" clearable
                                        @input="editmenu = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col>
                                <v-btn fab small
                                    @click="currentItem.date_sent = null"><v-icon>mdi-delete</v-icon></v-btn>
                            </v-col>
                        </v-row>
                        <v-text-field :rules="[rules.required]" required label="Ügyletszám"
                            v-model="currentItem.deal_number">
                        </v-text-field>
                        <v-select :rules="[rules.required]" required label="Bank neve" v-model="currentItem.bank_name"
                            :items="sortedBanks">
                        </v-select>

                        <v-row align="center">
                            <v-col>
                                <v-menu v-model="editClientDate" :close-on-content-click="false" :nudge-right="40"
                                    transition="scale-transition" offset-y>
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-model="formattedClientDateEdit" label="Időpont"
                                            v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="currentDate"
                                        @input="editClientDate = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col>
                                <v-btn fab small @click="currentDate = null"><v-icon>mdi-delete</v-icon></v-btn>
                            </v-col>
                            <v-col>
                                <v-btn rounded v-if="this.dates" @click="showDates = true">
                                    Múltbeli időpontok<v-avatar color="green" size="24">
                                        {{ this.dates.length }}
                                    </v-avatar>
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-text-field :rules="[rules.required, rules.phone]" required
                            :disabled="admin != 'administrator'" label="Elérhetőség 1 (telefon)"
                            v-model="currentItem.contact_one">
                        </v-text-field>
                        <v-text-field :rules="[rules.required, rules.email]" :disabled="admin != 'administrator'"
                            label="Elérhetőség 2 (e-mail)" required type="email" v-model="currentItem.contact_two">
                        </v-text-field>
                        <v-text-field :rules="[rules.required]" label="Kapcsolattartó neve" required
                            v-model="currentItem.contact_name">
                        </v-text-field>
                        <v-text-field label="Új megjegyzés" v-model="newComment">
                        </v-text-field>
                        <v-textarea label="Megjegyzés" v-model="formattedText" :disabled="admin != 'administrator'">
                        </v-textarea>
                        <v-select v-if="admin" :rules="[rules.required]" required label="Jutalék elszámolva"
                            v-model="currentItem.is_commission_settled" :items="settled">
                        </v-select>
                        <v-text-field label="Létrehozta" disabled v-model="currentItem.created_by">
                        </v-text-field>
                        <v-text-field label="Létrehozás dátuma" disabled v-model="currentItem.created_date">
                        </v-text-field>
                        <v-text-field label="Módosította" disabled v-model="currentItem.modified_by">
                        </v-text-field>
                        <v-text-field label="Módosítás dátuma" disabled v-model="currentItem.modified_date">
                        </v-text-field>
                        <v-row>
                            <v-col>
                                <div class="text-start">
                                    <v-btn rounded color="secondary" @click="closeDialog()">Bezárás</v-btn>
                                </div>
                            </v-col>
                            <v-col>
                                <div class="text-end">
                                    <v-btn rounded color="primary"
                                        @click="duplicateClient(currentItem)">Duplikáció</v-btn>
                                    <v-btn rounded color="success" class="ml-2"
                                        @click="editClient(currentItem)">Mentés</v-btn>
                                    <v-btn rounded v-if="this.admin" class="ml-2 mt-3" color="error"
                                        @click="deleteDialog = true">Törlés</v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="deleteDialog" persistent width="300">
            <v-card>
                <v-toolbar>
                    <v-toolbar-title>
                        Biztosan törölni szeretné?
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text class="mt-5">
                    <v-row>
                        <v-col>
                            <div class="text-start">
                                <v-btn rounded color="secondary" @click="deleteDialog = false">Nem</v-btn>
                            </div>
                        </v-col>
                        <v-col>
                            <div class="text-end">
                                <v-btn rounded v-if="this.admin" class="ml-2" color="error"
                                    @click="deleteClient()">Igen</v-btn>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="createDialog" width="600" scrollable persistent>
            <v-card>
                <v-alert type="error" dismissible v-model="fail">Hiba! Sikertelen mentés. Hibaüzenet: {{ this.error }}
                </v-alert>
                <v-toolbar>
                    <v-toolbar-title>Létrehozás</v-toolbar-title>
                </v-toolbar>
                <v-divider class="mt-3"></v-divider>
                <v-card-text ref="createDialogScrollArea">
                    <v-form>
                        <v-select :rules="[rules.required]" required label="Termék" v-model="currentItem.product"
                            :items="products">
                        </v-select>
                        <v-select :rules="[rules.required]" required label="Igénylés típusa"
                            v-model="currentItem.request_type" :items="sortedRequests">
                        </v-select>
                        <v-text-field :rules="[rules.required]" required label="Ügyfél neve"
                            v-model="currentItem.client_name">
                        </v-text-field>
                        <v-row align="center">
                            <v-col>
                                <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40"
                                    transition="scale-transition" offset-y>
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-model="formattedDate" label="Küldés dátuma" readonly
                                            v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="selectedDate" @input="menu = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col>
                                <v-btn fab small @click="selectedDate = null"><v-icon>mdi-delete</v-icon></v-btn>
                            </v-col>
                        </v-row>
                        <v-text-field :rules="[rules.required]" required label="Ügyletszám"
                            v-model="currentItem.deal_number">
                        </v-text-field>
                        <v-select :rules="[rules.required]" required label="Bank neve" v-model="currentItem.bank_name"
                            :items="sortedBanks">
                        </v-select>
                        <v-row align="center">
                            <v-col>
                                <v-menu v-model="clientDateMenu" :close-on-content-click="false" :nudge-right="40"
                                    transition="scale-transition" offset-y>
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-model="formattedClientDate" label="Időpont"
                                            v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="clientDate" @input="clientDateMenu = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col>
                                <v-btn fab small @click="clientDate = null"><v-icon>mdi-delete</v-icon></v-btn>
                            </v-col>
                        </v-row>
                        <v-text-field :rules="[rules.required, rules.phone]" required label="Elérhetőség 1 (telefon)"
                            v-model="currentItem.contact_one">
                        </v-text-field>
                        <v-text-field :rules="[rules.required, rules.email]" required label="Elérhetőség 2 (e-mail)"
                            type="email" v-model="currentItem.contact_two">
                        </v-text-field>
                        <v-text-field :rules="[rules.required]" required label="Kapcsolattartó neve"
                            v-model="currentItem.contact_name">
                        </v-text-field>
                        <v-textarea label="Megjegyzés" v-model="currentItem.comment">
                        </v-textarea>
                    </v-form>
                    <v-row>
                        <v-col>
                            <div class="text-start">
                                <v-btn rounded class="mt-3 ml-2" color="secondary"
                                    @click="closeCreateDialog()">Bezárás</v-btn>
                            </div>
                        </v-col>
                        <v-col>
                            <div class="text-end">
                                <v-btn rounded class="mt-3 ml-2" color="primary"
                                    @click="createClient(currentItem)">Létrehozás</v-btn>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="showDates" width="240" scrollable>
            <v-card max-height="250">
                <v-toolbar>
                    <v-toolbar-title>Múltbeli időpontok</v-toolbar-title>
                </v-toolbar>
                <v-list>
                    <v-list-item v-for="(item, index) in dates" :key="index">
                        <v-list-item-title>{{ item }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import readXlsxFile from 'read-excel-file'
export default {
    name: "Clients",
    async mounted() {
        const system = process.env.VUE_APP_SYSTEM
        this.setSystem(system)
        const response = await fetch('/.auth/me');
        const payload = await response.json();
        const { clientPrincipal } = payload;
        this.admin = clientPrincipal.userRoles.find((role) => role == "administrator");
        this.refreshNeeded = false
        this.currentUser = clientPrincipal.userDetails
        if (this.admin) {
            this.tableHeaders.splice(5, 0, { value: 'is_commission_settled', text: 'Jutalék elszámolva' })
        }
        this.setSelfRefresh()
        this.fetchClients(false)
        const now = new Date();
        const hours = now.getHours();
        if (hours < 23 && hours > 6) {
            window.setInterval(() => {
                this.fetchClients(true)
                this.deleteClient(true);
                this.uploadClients(null, true);
                this.editClient(null, true);
                this.createClient(null, true);
                this.getRefresh();
            }, 240000);
        }
    },
    methods: {
        async fetchClients(ping) {
            try {
                let pinged = 1
                if (!ping) {
                    pinged = 0
                    this.loading = true
                }
                const resp = await fetch(this.domain + this.getClintUrl + "/" + pinged, {
                    method: "GET",
                    headers: {
                        "x-functions-key": process.env.VUE_APP_MASTER_KEY
                    }
                })
                if (!ping) {
                    const payload = await resp.json()
                    payload.forEach((item) => {
                        if (item.date_sent != null && item.date_sent != "") {
                            item.date_sent = item.date_sent.split("T")[0]
                        }
                        if (item.client_date != null && item.client_date != "") {
                            item.client_date = item.client_date.split("T")[0]
                        }
                        item.created_date = item.created_date.split("T")[0]
                        item.modified_date = item.modified_date.split("T")[0]
                    })
                    this.items = payload
                    this.loading = false
                }
            }
            catch (err) {
                this.error = err
            }
        },
        async deleteClient(ping) {
            if (ping) {
                try {
                    await fetch(this.domain + this.deleteClientUrl + null, {
                        method: "DELETE",
                        headers: {
                            "x-functions-key": process.env.VUE_APP_MASTER_KEY
                        }
                    })
                } catch (err) { console.log("Delete pinged.") }

            } else {
                let client = this.currentItem
                try {
                    await fetch(this.domain + this.deleteClientUrl + client.Id, {
                        method: "DELETE",
                        headers: {
                            "x-functions-key": process.env.VUE_APP_MASTER_KEY
                        }
                    })
                    this.fetchClients(false)
                    this.deleteDialog = false
                    this.dialog = false
                    this.putRefresh()
                }
                catch (err) {
                    this.error = err
                }
            }

        },

        async deleteClients() {
            let clients = this.selected
            try {
                for (const client of clients) {
                    await fetch(this.domain + this.deleteClientUrl + client.Id, {
                        method: "DELETE",
                        headers: {
                            "x-functions-key": process.env.VUE_APP_MASTER_KEY
                        }
                    })

                }
                this.putRefresh()
                this.selected = []
                this.fetchClients(false)

            }
            catch (err) {
                this.error = err
            }

        },
        async uploadClients(clients, ping) {
            if (ping) {
                try {
                    await fetch(this.domain + this.postClientsUrl, {
                        method: "POST",
                        body: null,
                        headers: {
                            "Content-type": "application/json; charset=UTF-8",
                            "x-functions-key": process.env.VUE_APP_MASTER_KEY
                        }
                    })
                } catch (err) { console.log("POSTS pinged.") }
            } else {
                try {
                    let clientJson = JSON.stringify(clients)
                    const response = await fetch(this.domain + this.postClientsUrl, {
                        method: "POST",
                        body: clientJson,
                        headers: {
                            "Content-type": "application/json; charset=UTF-8",
                            "x-functions-key": process.env.VUE_APP_MASTER_KEY
                        }
                    })
                    if (response.status == 200) {
                        this.fetchClients(false)
                        this.success = true
                        this.putRefresh()
                    } else {
                        this.uploadFail = true
                        this.error = response.statusText
                    }
                }
                catch (err) {
                    this.error = err
                }
            }
        },
        async duplicateClient(client) {
            if (this.allRequiredFieldsFilled(client)) {
                client['created_by'] = this.findUser(this.currentUser)
                client['created_date'] = (new Date()).toISOString().split('T')[0]
                client['modified_by'] = this.findUser(this.currentUser)
                client['modified_date'] = (new Date()).toISOString().split('T')[0]
                let comment = client['comment']
                if (comment != undefined) {
                    if (this.newComment != "") {
                        client['comment'] = "[" + this.getFormattedDate() + ", " + this.findUser(this.currentUser) + "] " + this.newComment + " " + comment
                    } else {
                        client['comment'] = this.updateDatabaseString(this.formattedText, comment)
                    }
                } else {
                    client['comment'] = ""
                }
                let clientJson = JSON.stringify(client)
                const response = await fetch(this.domain + this.postClientUrl, {
                    method: "POST",
                    body: clientJson,
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",
                        "x-functions-key": process.env.VUE_APP_MASTER_KEY
                    }
                })
                if (response.status == 200) {
                    this.fetchClients(false)
                    this.closeDialog()
                    this.success = true
                    this.currentItem = {}
                    this.putRefresh()
                } else {
                    this.fail = true
                    this.error = response.statusText
                }
            } else {
                this.fail = true
                this.error = "Minden szükséges mező kitöltése kötelező!"
            }
        },
        async editClient(client, ping) {
            if (ping) {
                try {
                    await fetch(this.domain + this.putClientUrl, {
                        method: "PUT",
                        body: null,
                        headers: {
                            "Content-type": "application/json; charset=UTF-8",
                            "x-functions-key": process.env.VUE_APP_MASTER_KEY
                        }
                    })
                } catch (e) {
                    console.log("Put pinged.")
                }
            } else {
                if (this.allRequiredFieldsFilled(client)) {
                    client['modified_by'] = this.findUser(this.currentUser)
                    client['modified_date'] = (new Date()).toISOString().split('T')[0]
                    let comment = client['comment']
                    if (comment != undefined) {
                        if (this.newComment != "") {
                            client['comment'] = "[" + this.getFormattedDate() + ", " + this.findUser(this.currentUser) + "] " + this.newComment + " " + comment
                        } else {
                            client['comment'] = this.updateDatabaseString(this.formattedText, comment)
                        }
                    } else {
                        client['comment'] = ""
                    }
                    if (this.currentDate != this.getLastDate(client['client_date'])) {
                        client['client_date'] = this.addDate(client['client_date'], this.currentDate)
                    }
                    let clientJson = JSON.stringify(client)
                    const response = await fetch(this.domain + this.putClientUrl, {
                        method: "PUT",
                        body: clientJson,
                        headers: {
                            "Content-type": "application/json; charset=UTF-8",
                            "x-functions-key": process.env.VUE_APP_MASTER_KEY
                        }
                    })
                    if (response.status == 200) {
                        this.fetchClients(false)
                        this.closeDialog()
                        this.success = true
                        this.currentItem = {}
                        this.currentDate = null
                        this.putRefresh()
                    } else {
                        this.fail = true
                        this.error = response.statusText
                    }
                } else {
                    this.fail = true
                    this.error = "Minden szükséges mező kitöltése kötelező!"
                }
            }
        },
        async createClient(client, ping) {
            if (ping) {
                try {
                    await fetch(this.domain + this.postClientUrl, {
                        method: "POST",
                        body: null,
                        headers: {
                            "Content-type": "application/json; charset=UTF-8",
                            "x-functions-key": process.env.VUE_APP_MASTER_KEY
                        }
                    })
                } catch (err) { console.log("POST pinged.") }
            } else {
                client.is_commission_settled = "Nem"
                if (this.allRequiredFieldsFilled(client)) {
                    client['created_by'] = this.findUser(this.currentUser)
                    client['created_date'] = (new Date()).toISOString().split('T')[0]
                    client['modified_by'] = this.findUser(this.currentUser)
                    client['modified_date'] = (new Date()).toISOString().split('T')[0]
                    let comment = client['comment']
                    client['date_sent'] = this.selectedDate
                    client['client_date'] = this.clientDate
                    if (comment != undefined) {
                        client['comment'] = "[" + this.getFormattedDate() + ", " + this.findUser(this.currentUser) + "] " + comment + " "
                    } else {
                        client['comment'] = ""
                    }
                    let clientJson = JSON.stringify(client)
                    const response = await fetch(this.domain + this.postClientUrl, {
                        method: "POST",
                        body: clientJson,
                        headers: {
                            "Content-type": "application/json; charset=UTF-8",
                            "x-functions-key": process.env.VUE_APP_MASTER_KEY
                        }
                    })
                    if (response.status == 200) {
                        this.fetchClients(false)
                        this.closeCreateDialog()
                        this.success = true
                        this.selectedDate = null
                        this.putRefresh()
                    } else {
                        this.fail = true
                        this.error = response.statusText
                    }
                } else {
                    this.fail = true
                    this.error = "Minden szükséges mező kitöltése kötelező!"
                }
            }
        },
        async setSelfRefresh() {
            await fetch(this.domain + this.setSelfRefreshUrl, {
                method: "PUT",
                body: JSON.stringify({ username: this.currentUser, isRefreshNeeded: false }),
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "x-functions-key": process.env.VUE_APP_MASTER_KEY
                }
            })
        },
        async getRefresh() {
            const resp = await fetch(this.domain + this.getRefreshUrl + "/" + this.currentUser, {
                method: "GET",
                headers: {
                    "x-functions-key": process.env.VUE_APP_MASTER_KEY
                }
            })
            const payload = await resp.json()
            this.refreshData = payload
            this.isRefreshNeeded = payload.isRefreshNeeded
        },
        async putRefresh() {
            await fetch(this.domain + this.putRefreshUrl, {
                method: "PUT",
                body: JSON.stringify({ username: this.currentUser, isRefreshNeeded: true }),
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "x-functions-key": process.env.VUE_APP_MASTER_KEY
                }
            })
        },
        setSystem(system) {
            this.pingUrl = "/api/ping_server"
            this.getRefreshUrl = "/api/get_refresh"
            this.putRefreshUrl = "/api/put_refresh"
            this.setSelfRefreshUrl = "/api/put_self_refresh"
            if (system == "PROD") {
                this.domain = process.env.VUE_APP_PROD_DOMAIN
                this.getClintUrl = "/api/get_clients"
                this.postClientUrl = "/api/post_client"
                this.deleteClientUrl = "/api/delete_client/"
                this.postClientsUrl = "/api/post_clients"
                this.putClientUrl = "/api/put_client"
            } else if (system == "DEV") {
                this.domain = process.env.VUE_APP_DEV_DOMAIN
                this.getClintUrl = "/api/tst_get_clients"
                this.postClientUrl = "/api/tst_post_client"
                this.deleteClientUrl = "/api/tst_delete_client/"
                this.postClientsUrl = "/api/tst_post_clients"
                this.putClientUrl = "/api/tst_put_client"
            }
        },
        getFormattedDate() {
            const date = new Date();
            const formattedDate = date.getFullYear() + '-' +
                ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
                ('0' + date.getDate()).slice(-2) + ' ' +
                ('0' + date.getHours()).slice(-2) + ':' +
                ('0' + date.getMinutes()).slice(-2);
            return formattedDate

        },
        getFormattedFromDate(d) {
            const date = new Date(d);
            const formattedDate = date.getFullYear() + '-' +
                ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
                ('0' + date.getDate()).slice(-2)
            return formattedDate

        },
        extractFirstElement(dbString) {
            if (!dbString) {
                return null;
            }

            dbString = dbString.replace(/\n/g, ' ').trim();

            let firstElement = '';

            let foundTimestamp = false;

            let i = 0;
            while (i < dbString.length) {
                if (dbString[i] === '[' && !foundTimestamp) {
                    let endIdx = dbString.indexOf(']', i);
                    if (endIdx !== -1) {
                        firstElement += dbString.slice(i, endIdx + 1) + ' ';
                        foundTimestamp = true;
                        i = endIdx + 1;
                    } else {
                        break;
                    }
                } else if (foundTimestamp) {
                    if (dbString[i] === '[') {
                        break;
                    }
                    firstElement += dbString[i];
                    i++;
                } else {
                    i++;
                }
            }

            return firstElement.trim() || null;
        },
        updateDatabaseString(uiString, dbString) {
            let uiLines = uiString.split('\n').map(line => line.trim()).filter(line => line !== '');

            let dbSegments = dbString.split(/\s*(?=\[)/).map(segment => segment.trim()).filter(segment => segment !== '');

            if (uiLines.length === 0) {
                return '';
            }

            let updatedDbString = '';
            let uiIndex = 0;
            let dbIndex = 0;

            while (uiIndex < uiLines.length || dbIndex < dbSegments.length) {
                if (uiIndex < uiLines.length && dbIndex < dbSegments.length) {
                    if (uiLines[uiIndex] !== dbSegments[dbIndex]) {
                        updatedDbString += uiLines[uiIndex] + ' ';
                    } else {
                        updatedDbString += dbSegments[dbIndex] + ' ';
                    }
                    uiIndex++;
                    dbIndex++;
                }
                else if (uiIndex < uiLines.length) {
                    updatedDbString += uiLines[uiIndex] + ' ';
                    uiIndex++;
                }
                else if (dbIndex < dbSegments.length) {
                    dbIndex++;
                }
            }

            updatedDbString = updatedDbString.trim();

            return updatedDbString;
        },
        allRequiredFieldsFilled(obj) {
            if (Object.keys(obj).length === 0) {
                return false;
            }
            if (obj['bank_name'] === null || obj['bank_name'] === undefined || obj['bank_name'] === "") {
                return false;
            }
            if (obj['contact_name'] === null || obj['contact_name'] === undefined || obj['contact_name'] === "") {
                return false;
            }
            if (obj['contact_one'] === null || obj['contact_one'] === undefined || !this.phoneNumberCheck(obj['contact_one'] || obj['contact_one'] === "")) {
                return false;
            }
            if (obj['contact_two'] === null || obj['contact_two'] === undefined || !this.emailCheck(obj['contact_two'] || obj['contact_two'] === "")) {
                return false;
            }
            if (obj['product'] === null || obj['product'] === undefined || obj['product'] === "") {
                return false;
            }
            if (obj['request_type'] === null || obj['request_type'] === undefined || obj['request_type'] === "") {
                return false;
            }
            if (obj['deal_number'] === null || obj['deal_number'] === undefined || obj['deal_number'] === "") {
                return false;
            }
            if (obj['client_name'] === null || obj['client_name'] === undefined || obj['client_name'] === "") {
                return false;
            }
            if (obj['is_commission_settled'] === null || obj['is_commission_settled'] === undefined || obj['is_commission_settled'] === "") {
                return false;
            }
            return true
        },
        findUser(email) {
            let name = ""
            this.users.forEach((user) => {
                if (user.email == email) {
                    name = user.name
                }
            })
            return name
        },
        openCreateDialog() {
            this.createDialog = true
        },
        closeCreateDialog() {
            this.createDialog = false
            this.currentItem = {}
            this.fail = false
            this.newComment = ""
            this.selectedDate = null
            this.clientDate = null
        },
        itemColor: function (item) {
            if (item.is_commission_settled === "Tárgytalan") {
                return 'background-color: #ffebee;'
            } else if (item.is_commission_settled === "Igen") {
                return 'color: rgb(6,152,33);'
            }
            return ''
        },
        formatText(text) {
            return text.replace(/\[(.*?)\]/g, "\n[$1]")
        },
        revertFormattedText(formattedText) {
            return formattedText.replace(/\[(.*?)\]/g, " [$1]")
        },
        addDate(existingDates, newDate) {
            if (!existingDates) {
                return newDate;
            }

            const datesArray = existingDates.split(',');
            datesArray.push(newDate);

            return datesArray.join(',');
        },
        getLastDate(datesString) {
            if (!datesString || typeof datesString !== 'string') {
                return null;
            }

            const datesArray = datesString.split(',');

            if (datesArray.length === 0) {
                return null;
            }

            return datesArray[datesArray.length - 1];
        },
        getAllExceptLast(datesString) {
            if (!datesString) return [];

            const datesArray = datesString.split(',');

            // Find index of last non-empty element
            let lastNonEmptyIndex = -1;
            for (let i = datesArray.length - 1; i >= 0; i--) {
                if (datesArray[i].trim() !== '') {
                    lastNonEmptyIndex = i;
                    break;
                }
            }

            // Check if there are any non-empty elements after the last non-empty one
            const hasTrailingEmpty = datesArray.slice(lastNonEmptyIndex + 1).some(e => e.trim() === '');

            // If the last non-empty is at the very end and no trailing empties, remove it
            if (!hasTrailingEmpty && lastNonEmptyIndex >= 0) {
                return datesArray.slice(0, lastNonEmptyIndex).filter(e => e.trim() !== '');
            }

            // Otherwise, return all non-empty elements
            return datesArray.filter(e => e.trim() !== '');
        },
        onDialogChange(val) {
            if (val) {
                this.$nextTick(() => {
                    const scrollEl = this.$refs.scrollArea;
                    if (scrollEl) {
                        scrollEl.scrollTop = 0;
                    }
                });
            }
        },
        showModal: function (item) {
            this.dialog = true
            this.currentItem = item
            let date = this.currentItem.client_date
            this.dates = this.getAllExceptLast(date)
            this.currentDate = this.getLastDate(date)
            this.formattedText = this.formatText(item.comment)
        },
        closeDialog() {
            this.dialog = false
            this.currentItem = {}
            this.currentDate = null
            this.dates = null
            this.fail = false
            this.newComment = ""
            this.formattedText = ""
            this.clientDate = null
            this.selectedDate = null
        },

        phoneNumberCheck(item) {
            let regex = /^\+36\d{9}$/
            return regex.test(item)
        },
        emailCheck(item) {
            let regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
            return regex.test(item)
        },
        uploadXlsx() {
            let clients = []
            readXlsxFile(this.file).then((rows) => {
                let first = true
                rows.forEach((row) => {
                    if (!first) {
                        let i = 0
                        let data = {}
                        this.headers.forEach((h) => {
                            let item = row[i]
                            data[h.value] = item
                            i++
                        })
                        data['is_commission_settled'] = "Nem"
                        data['created_by'] = this.findUser(this.currentUser)
                        data['created_date'] = (new Date()).toISOString().split('T')[0]
                        data['modified_by'] = this.findUser(this.currentUser)
                        data['modified_date'] = (new Date()).toISOString().split('T')[0]
                        clients.push(data)
                    }
                    first = false
                })
                this.uploadClients(clients)
            })
            this.file = null
        },
        getColumnType(columnValue) {
            return this.selectColumns.includes(columnValue) ? 'select' : 'text';
        },

        getUniqueValues(columnValue) {
            const values = this.items
                .map(item => item[columnValue])
                .filter(value => value !== null && value !== undefined && value !== '')
                .filter((value, index, self) => self.indexOf(value) === index)
                .sort();

            return values;
        },

        getColumnWidth() {
            return Math.floor(12 / this.filteredHeaders.length);
        },

        clearAllFilters() {
            this.columnFilters = {};
        },
        clearColumnFilter(column) {
            // Clear specific column filter
            this.$set(this.columnFilters, column, this.selectColumns.includes(column) ? [] : '');
        },
    },
    watch: {
        inputText(newText) {
            // Call the formatText function whenever the input text changes
            this.formattedText = this.formatText(newText);
        },
        dialog(val) {
            if (val) {
                this.$nextTick(() => {
                    const scrollArea = this.$refs.dialogScrollArea;
                    if (scrollArea && scrollArea.scrollTop !== undefined) {
                        scrollArea.scrollTop = 0;
                    }
                });
            }
        },
        createDialog(val) {
            if (val) {
                this.$nextTick(() => {
                    const scrollArea = this.$refs.createDialogScrollArea;
                    if (scrollArea && scrollArea.scrollTop !== undefined) {
                        scrollArea.scrollTop = 0;
                    }
                });
            }
        }
    },
    beforeMount() {

    },
    computed: {
        sortedBanks() {
            return [...this.banks].sort(); // Spread operator creates a copy to avoid mutating original
        },
        sortedRequests() {
            return [...this.requests].sort(); // Spread operator creates a copy to avoid mutating original
        },
        filteredHeaders() {
            // Return headers that should have filters (exclude action columns, select column, etc.)
            return this.filterHeaders.filter(header =>
                header.value !== 'data-table-select' &&
                header.value !== 'actions' &&
                header.sortable !== false
            );
        },
        filteredItems() {
            let filtered = this.items;

            // Apply column filters
            Object.keys(this.columnFilters).forEach(column => {
                const filterValue = this.columnFilters[column];

                if (filterValue && filterValue !== '' && filterValue.length > 0) {
                    filtered = filtered.filter(item => {
                        const itemValue = item[column];
                        if (itemValue === null || itemValue === undefined) return false;

                        // For select columns with multiple selection
                        if (this.selectColumns.includes(column)) {
                            // If filterValue is an array (multiple selection)
                            if (Array.isArray(filterValue)) {
                                return filterValue.includes(itemValue);
                            }
                            // If filterValue is a single value
                            return itemValue === filterValue;
                        }
                        // For text columns, partial match (case insensitive)
                        return itemValue.toString().toLowerCase().includes(filterValue.toLowerCase());
                    });
                }
            });

            return filtered;
        },

        formattedDate() {
            if (!this.selectedDate) return null;
            const [year, month, day] = this.selectedDate.split('-');
            return `${year}-${month}-${day}`;
        },
        formattedDateEdit() {
            if (!this.currentItem.date_sent) return null;
            const [year, month, day] = this.currentItem.date_sent.split('-');
            return `${year}-${month}-${day}`;
        },
        formattedClientDate() {
            if (!this.clientDate) return null;
            const [year, month, day] = this.clientDate.split('-');
            return `${year}-${month}-${day}`;
        },
        formattedClientDateEdit() {
            if (!this.currentDate) return null;
            const [year, month, day] = this.currentDate.split('-');
            return `${year}-${month}-${day}`;
        }
    },
    data() {
        return {
            isRefreshNeeded: false,
            refreshData: {},
            columnFilters: {},
            selectColumns: ['product', 'request_type', 'bank_name', 'is_commission_settled'],
            formattedText: "",
            domain: null,
            dates: null,
            currentDate: null,
            showDates: false,
            getClintUrl: null,
            putRefreshUrl: null,
            getRefreshUrl: null,
            setSelfRefreshUrl: null,
            postClientUrl: null,
            deleteClientUrl: null,
            postClientsUrl: null,
            putClientUrl: null,
            pingUrl: null,
            loading: false,
            uploadFail: false,
            deleteDialog: false,
            success: false,
            fail: false,
            admin: null,
            newComment: "",
            currentUser: null,
            selectedDate: null,
            clientDate: null,
            menu: false,
            clientDateMenu: null,
            from_date: null,
            selected: [],
            error: null,
            editmenu: false,
            editClientDate: false,
            file: null,
            rules: {
                required: value => !!value || 'Kötelezően kitöltendő',
                email: value => {
                    const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                    return pattern.test(value) || 'Helytelen e-mail.'
                },
                phone: value => {
                    const pattern = /^\+36\d{9}$/
                    return pattern.test(value) || 'A telefonszámot ilyen formátumban kell megadni: +36201111111'
                },
            },
            users: [
                {
                    name: "Faragó István",
                    email: "szkpbekas01@gmail.com"
                },
                {
                    name: "Kóta Zsanett",
                    email: "szkpbekas@gmail.com"
                }
            ],
            banks: [
                "OTP", "Cib", "Erste", "MBH", "Raiffeisen", "Unicredit", "Merkantil", "Euroleasing", "Deutsche", "BG", "Hitelpont", "Alfa", "MZH", "K&H", "Oberbank", "Magnet", "UC",
                "Toyota Pénzügyi", "Ober Pénzügyi Lízing", "OTP Ingatlanlízing", "UniCredit Leasing", "CIB Lízing", "Mercedes–Benz Credit",
                "Raiffeisen Corporate Lízing", "Porsche Finance", "Cofidis Magyarországi Fióktelepe", "SGEF", "PannonHitel", "Carion", "MGV Zrt.,", "KAVOSZ Vállalkozásfejlesztési Zrt",
                "City-Faktor", "Cib Lízing", "Arteus Credit", "Partner Capital"
            ],
            requests: [
                "Új", "Felülvizsgálat", "Hosszabbítás", "Keretemelés", "Hitelkiváltás", "Hosszabbítás és keretemelés",
                "Keretcsökkentés", "Keretemelés bankváltással", "Hitelkiváltás bankváltással"
            ],
            products: [
                "SZK, SZTK", "ASZK", "SZLikvid", "SZB, ASZB", "SzMikro", "SzLízing"
            ],
            settled: [
                "Igen", "Nem", "Tárgytalan", "Függő"
            ],
            currentItem: {},
            dialog: false,
            createDialog: false,
            search: '',
            filterHeaders: [
                {
                    value: 'product',
                    text: 'Termék'
                },
                { value: 'request_type', text: 'Igénylés típusa' },
                { value: 'bank_name', text: 'Bank neve' },
                { value: 'is_commission_settled', text: 'Jutalék elszámolva' },
            ],
            tableHeaders: [
                {
                    align: ' d-none',
                    value: 'Id',
                    text: 'Id'
                },
                {
                    value: 'product',
                    text: 'Termék'
                },
                { value: 'request_type', text: 'Igénylés típusa' },
                { value: 'client_name', text: 'Ügyfél neve' },
                { value: 'date_sent', text: 'Küldés dátuma' },
                { align: ' d-none', value: 'deal_number', text: 'Ügyletszám' },
                { value: 'bank_name', text: 'Bank neve' },
                { value: 'client_date', text: 'Időpont' },
                { align: ' d-none', value: 'contact_one', text: 'Elérhetőség 1 (telefon)' },
                { align: ' d-none', value: 'contact_two', text: 'Elérhetőség 2 (e-mail)' },
                { align: ' d-none', value: 'contact_name', text: 'Kapcsolattartó neve' },
                { value: 'comment', text: 'Megjegyzés' },
                { align: ' d-none', value: 'created_by', text: 'Létrehozta' },
                { align: 'start', value: 'created_date', text: 'Létrehozás dátuma' },
                { value: 'modified_by', text: 'Módosította' },
                { align: ' d-none', value: 'modified_date', text: 'Módosítás dátuma' }
            ],
            headers: [
                {
                    align: 'start',
                    value: 'product',
                    text: 'Termék'
                },
                { value: 'request_type', text: 'Igénylés típusa' },
                { value: 'client_name', text: 'Ügyfél neve' },
                { value: 'date_sent', text: 'Küldés dátuma' },
                { value: 'deal_number', text: 'Ügyletszám' },
                { value: 'bank_name', text: 'Bank neve' },
                { value: 'contact_one', text: 'Elérhetőség 1 (telefon)' },
                { value: 'contact_two', text: 'Elérhetőség 2 (e-mail)' },
                { value: 'contact_name', text: 'Kapcsolattartó neve' },
                { value: 'comment', text: 'Megjegyzés' },
                { value: 'created_by', text: 'Létrehozta' },
                { value: 'created_date', text: 'Létrehozás dátuma' },
                { value: 'modified_by', text: 'Módosította' },
                { value: 'modified_date', text: 'Módosítás dátuma' },
                { value: 'is_commission_settled', text: 'Jutalék elszámolva' },
                { value: 'client_date', text: 'Időpont' }
            ],
            columns: [
                { field: 'product', label: 'Termék' },
                { field: 'request_type', label: 'Igénylés típusa' },
                { field: 'client_name', label: 'Ügyfél neve' },
                { field: 'date_sent', label: 'Küldés dátuma' },
                { field: 'deal_number', label: 'Ügyletszám' },
                { field: 'bank_name', label: 'Bank neve' },
                { field: 'client_date', label: 'Időpont' },
                { field: 'contact_one', label: 'Elérhetőség 1 (telefon)' },
                { field: 'contact_two', label: 'Elérhetőség 2 (e-mail)' },
                { field: 'contact_name', label: 'Kapcsolattartó neve' },
                { field: 'comment', label: 'Megjegyzés' },
                { field: 'is_commission_settled', label: 'Jutalék elszámolva' },
                { field: 'created_by', label: 'Létrehozta' },
                { field: 'created_date', label: 'Létrehozás dátuma' },
                { field: 'modified_by', label: 'Módosította' },
                { field: 'modified_date', label: 'Módosítás dátuma' },
            ],
            items: []
        }
    }
}
</script>
<style scoped>
.uniform-filter-field {
    min-width: 120px;
}

.uniform-filter-field>>>.v-field {
    height: 40px !important;
    min-height: 40px !important;
}

.uniform-filter-field>>>.v-field__input {
    height: 40px !important;
    min-height: 40px !important;
    padding-top: 8px !important;
    padding-bottom: 8px !important;
    flex-wrap: nowrap !important;
    overflow: hidden !important;
}

.uniform-filter-field>>>.v-field__field {
    height: 40px !important;
}

.uniform-filter-field>>>.v-select__selection {
    max-height: 24px !important;
    overflow: hidden !important;
}

.filter-chip {
    height: 20px !important;
    max-height: 20px !important;
    font-size: 11px !important;
    margin: 1px !important;
}

.filter-count {
    font-size: 10px !important;
    color: #666 !important;
    white-space: nowrap !important;
}

/* Ensure text fields have consistent height */
.uniform-filter-field>>>.v-input__control {
    min-height: 40px !important;
    height: 40px !important;
}

/* Hide extra margin/padding that might cause height differences */
.uniform-filter-field>>>.v-field__append-inner,
.uniform-filter-field>>>.v-field__prepend-inner {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
}

/* Ensure dropdown arrow is properly positioned */
.uniform-filter-field>>>.v-select__menu-icon {
    margin-top: 0 !important;
}
</style>
